import { Box, Flex, Text } from '@chakra-ui/react'
import React from 'react'
import {motion} from 'framer-motion'
export const Important = () => {
  return (
    <motion.div initial={{ opacity: 0 }}
    whileInView={{ opacity: 1,transition:{duration: 1}}}>
    <Flex justifyContent={'center'} flexDirection={'column'} textAlign={'center'}>
        <Text as={'h2'} fontSize={'1.5rem'} margin={'1rem'}>Aclaraciones importantes:</Text>
        <Box margin={'auto'} >
        <Text margin={'1rem'} fontSize={'1.3rem'} fontWeight={'900'}>Pagos:</Text>
        <Box padding={'1rem'} border={'1px solid rgba(0, 0, 0, 0.42)'} width={{xs:'250px', sm:'300px',ls:'500px',md:'600px',lg:'600px',xl:'900px'}} boxShadow={' 0px 4px 13px 3px rgba(0, 0, 0, 0.25)'}>
            <Box>
            <Text>
            Todos los precios mencionados anteriormente son <b>mensuales.</b>
            </Text>
            <Text>
            Se deberá abonar el 50% dentro de los primeros 5 (Cinco) días del mes y el dinero restante al finalizar el mismo.
            </Text>
            <Text>
                Los medios de pago pueden ser: Efectivo o Transferencia bancaria
            </Text>
            </Box>
        </Box>
        </Box>
        <Box margin={'auto'} >
        <Text margin={'1rem'} fontSize={'1.3rem'} fontWeight={'900'}>Antes de comenzar:</Text>
        <Box padding={'1rem'} border={'1px solid rgba(0, 0, 0, 0.42)'} width={{xs:'250px', sm:'300px',ls:'500px',md:'600px',lg:'600px',xl:'900px'}} boxShadow={' 0px 4px 13px 3px rgba(0, 0, 0, 0.25)'}>
            <Box>
            <Text>
            Cada plan cuenta con el análisis previo para conocer la marca.
            </Text>
            <Text>
            Se pactarán al menos 2 entrevistas.
            </Text>
            <Text>
            En cada precio está contemplada la creación de un Arquetipo de cliente (Para saber a quiénes le vamos a hablar) y un Brief (Para saber a dónde estamos parados inicialmente).
            </Text> 
            </Box>
        </Box>
        </Box>
        <Box margin={'auto'} >
        <Text margin={'1rem'} fontSize={'1.3rem'} fontWeight={'900'}>Modalidad de trabajo:</Text>
        <Box padding={'1rem'} border={'1px solid rgba(0, 0, 0, 0.42)'} width={{xs:'250px', sm:'300px',ls:'500px',md:'600px',lg:'600px',xl:'900px'}} boxShadow={' 0px 4px 13px 3px rgba(0, 0, 0, 0.25)'}>
            <Box>
            <Text margin={'0.3rem'}>
                Una vez finalizada la etapa de entrevista y análisis, se comenzará a <b>crear el contenido y editarlo,</b> luego se <b>armará un calendario de contenidos.</b>
                <Text  margin={'0.3rem'}>
                Este mismo será entregado <b>7 días antes </b> de la fecha del  primer posteo y se necesita una <b>aprobación </b> para poder iniciar. Dentro de esta semana se pueden realizar cambios en los mismos.
                Todo lo que se quiera comunicar ya sean promociones, sorteos y demás debe ser comunicado a la CM antes de la creación del calendario.
                </Text>
                <Text  margin={'0.3rem'}>
                En caso de haber contratado el plan Estándar o Premium:
                Al finalizar el mes, <b> luego de 4 días </b> se entregará el reporte de métricas destacando los progresos.
                En caso de contratar un paquete de plan y querer <b> agregar o quitar tareas </b>, los precios cambiarán, esto debe ser pactado con la CM. </Text>
                </Text>
            </Box>
        </Box>
        </Box>
    </Flex>
    </motion.div>

  )
}
